import React from "react";
import "./styles/carousel-styles.css";
const Carousel = () => {
  const images = [];
  images[0] = "./assets/Slideshow/352x352_Ape_Promo_2.png";
  images[1] = "./assets/Slideshow/352x352_Punk_Promo_4.png";
  images[2] = "./assets/Slideshow/352x352 Tundra Promo 3.jpg";
  images[3] = "./assets/Slideshow/352x352 Masks Promo 2.jpg";
  images[4] = "./assets/Slideshow/352x352 Desert Promo.jpg";
  images[5] = "./assets/Slideshow/352x352_Punk_Promo_5.png";
  images[6] = "./assets/Slideshow/352x352 Mask Promo 3.jpg";
  images[7] = "./assets/Slideshow/352x352 Desert Promo 3.jpg";
  images[8] = "./assets/Slideshow/352x352 Tundra Promo 2.jpg";
  images[9] = "./assets/Slideshow/352x352_Ape_Promo_3.png";
  return (
    <div id="carousel" className="main-outer-container slider">
      <div className="slide-track">
        {/* {images.forEach(image => {
                    return (
                        <div className="slide">
                           
    <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height= "100%" width="100%" alt=""/>// <img src={image} height="100%px" width100%52px" alt=""
 />
                        </div>
                    )
                })} */}

        <div className="slide">
          <img src={images[0]} height="100%" width="100%" alt="" />
          {/* <img src={images[0]} height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[1]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[2]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[3]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[4]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[5]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[6]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[7]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[8]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[9]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[0]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[1]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[2]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[3]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[4]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[5]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[6]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[7]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[8]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
        <div className="slide">
          <img src={images[9]} height="100%" width="100%" alt="" />
          {/* <img src="https://solblocks.tech/wp-content/uploads/2021/10/SolBlocks.-Logo.png" height="100%" width="100%" alt="" /> */}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
